import { ModelDetailSpecStrip } from './ModelDetailSpecStrip'
import type { SpecItem } from './ModelDetailSpecStrip'
import type { ChatModelMetadata } from '../types/unified-model.types'

interface ModelDetailStatsProps {
  meta: ChatModelMetadata
}

export function ModelDetailStats({ meta }: ModelDetailStatsProps) {
  const items: Array<SpecItem | null> = [
    { label: 'Context', value: meta.maxContext, unit: 'tokens' },
    { label: 'Max output', value: meta.maxOutput, unit: 'tokens' },
    meta.latency && meta.latency > 0
      ? { label: 'Latency', value: `~${meta.latency}`, unit: 'ms' }
      : null,
    meta.releasedAt ? { label: 'Released', value: meta.releasedAt } : null,
  ]

  return <ModelDetailSpecStrip items={items.filter((i): i is SpecItem => i !== null)} />
}
